export const UPDATE_LOCAL_COOKIE_CONSTANTS = {
    default: {
        locale: 'en',
        localeEn: 'en_US',
        currency: 'USD'
    },
};
